import { type AfterViewInit, Directive, ElementRef, inject, type OnDestroy } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ReplaySubject, takeUntil } from 'rxjs';

@Directive({
  selector: '[xiloDatePlaceholder]',
  standalone: true,
})
export class DatePlaceholderDirective<D> implements AfterViewInit, OnDestroy {
  private readonly dateAdapter = inject(DateAdapter<D>, { optional: true });
  private readonly el = inject(ElementRef);
  private readonly destroy$ = new ReplaySubject(1);

  ngAfterViewInit() {
    if (this.dateAdapter) {
      this.updatePlaceholder();
      this.dateAdapter.localeChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updatePlaceholder();
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  private updatePlaceholder() {
    if (this.el.nativeElement && this.dateAdapter) {
      try {
        const locale = this.dateAdapter['locale'];
        if (locale) {
          // This date allows us to detect parts of the date format
          const date = new Date(1998, 11, 24);
          const s = date.toLocaleDateString(locale, {
            weekday: undefined,
            year: 'numeric',
            month: '2-digit',
            day: 'numeric'
          });
          if (s) {
            const placeholder = s.trim()
              .replace('1998', 'YYYY')
              .replace('2541', 'YYYY') // Thai Buddhist calendar
              .replace('98', 'YY')
              .replace('41', 'YY')
              .replace('12', 'MM')
              .replace('24', 'DD');
            const allowedSymbols = ['Y', 'M', 'D', '.', ' ', '-', '/'];
            if (placeholder.split('').every(c => allowedSymbols.includes(c))) {
              this.el.nativeElement.placeholder = placeholder;
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
}